const PropTypes = require('prop-types');
// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');

// @commons
const Wizard = require('components/commons/wizard/wizard');
const BrokerHireDerivativesAccountStep1 = require('./brokerHireDerivativesAccountStep1/brokerHireDerivativesAccountStep1');
const BrokerHireDerivativesAccountStep2 = require('./brokerHireDerivativesAccountStep2/brokerHireDerivativesAccountStep2');

class BrokerHireDerivativesAccountWizard extends React.Component {
    constructor(props) {
        super(props);
        this.wizardWillCancel = this.wizardWillCancel.bind(this);
    }

    wizardWillCancel() {
        this.props.history.push('/myprofile/broker');
    }

    render() {
        const {
            immBrokerHireDerivativesAccount,
            immBrokerWallets,
            fetchAssociatedAccounts,
            fetchDerivatives,
            onAddIntervener,
            onRemoveIntervener,
            onResetInterveners,
            onSelectAssociatedAccount,
            onChangeAcceptManifest,
            onValidateStep,
            onSetVisibleStep,
            onFinish
        } = this.props;
        const visibleStep = immBrokerHireDerivativesAccount.get('visibleStep');
        const immSteps = immBrokerHireDerivativesAccount.get('steps');
        const actions = {
            validateStep: onValidateStep,
            setVisibleStep: onSetVisibleStep,
            setWillCancel: this.wizardWillCancel,
            finish: onFinish
        };

        return (
            <Wizard
                wizardClass="broker-hire-derivatives-account-wizard"
                actions={actions}
                immSteps={immSteps}
                stepsAmount={immSteps.size}
                visibleStep={visibleStep}
            >
                <BrokerHireDerivativesAccountStep1
                    immBrokerHireDerivativesAccount={immBrokerHireDerivativesAccount}
                    immBrokerWallets={immBrokerWallets}
                    onSelectAssociatedAccount={onSelectAssociatedAccount}
                    fetchAssociatedAccounts={fetchAssociatedAccounts}
                    fetchDerivatives={fetchDerivatives}
                    onAddIntervener={onAddIntervener}
                    onRemoveIntervener={onRemoveIntervener}
                    onResetInterveners={onResetInterveners}
                    actions={actions}
                />
                <BrokerHireDerivativesAccountStep2
                    immBrokerHireDerivativesAccount={immBrokerHireDerivativesAccount}
                    onChangeAcceptManifest={onChangeAcceptManifest}
                    actions={actions}
                />
            </Wizard>
        );
    }
}

BrokerHireDerivativesAccountWizard.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerHireDerivativesAccount: PropTypes.object.isRequired,
    immBrokerWallets: PropTypes.object.isRequired,
    fetchAssociatedAccounts: PropTypes.func.isRequired,
    fetchDerivatives: PropTypes.func.isRequired,
    onAddIntervener: PropTypes.func.isRequired,
    onRemoveIntervener: PropTypes.func.isRequired,
    onResetInterveners: PropTypes.func.isRequired,
    onSelectAssociatedAccount: PropTypes.func.isRequired,
    onChangeAcceptManifest: PropTypes.func.isRequired,
    onValidateStep: PropTypes.func.isRequired,
    onSetVisibleStep: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired
};

module.exports = withRouter(BrokerHireDerivativesAccountWizard);
